import { observable, action, computed } from "mobx"
import { SystemPreferencesDTO } from "@/gen/api"
import { makeObservable } from "mobx"

class PreferencesStore {
  @observable preferences: SystemPreferencesDTO | null = null
  @observable isLoading = false
  @observable isUpdating = false
  @observable error: string | null = null

  constructor() {
    makeObservable(this)
  }

  @action
  setPreferences(preferences: SystemPreferencesDTO) {
    this.preferences = preferences
    this.error = null
  }

  @action
  updatePreference<K extends keyof SystemPreferencesDTO>(key: K, value: SystemPreferencesDTO[K]) {
    this.preferences = this.preferences
      ? { ...this.preferences, [key]: value }
      : ({ [key]: value } as SystemPreferencesDTO)
  }

  @action
  setLoading(loading: boolean) {
    this.isLoading = loading
  }

  @action
  setUpdating(updating: boolean) {
    this.isUpdating = updating
  }

  @action
  setError(error: string | null) {
    this.error = error
  }

  @action
  clearPreferences() {
    this.preferences = null
    this.error = null
  }

  @computed
  get language() {
    return this.preferences?.language
  }
}

export const preferencesStore = new PreferencesStore()
